module.exports = __webpack_public_path__ + "img/footer-card.e7ae3152.png";